/**
 * 	Global imports
 */
import { createSelector } from 'reselect'
import { RootState } from '../store'

/**
 * Get User state object from global state
 * @type {object}
 */
const getUserSession = (state: RootState) => state.user

/**
 * Get user session from User state
 * @param {object} getUserSession [description]
 * @param {object} (appState) => { return appState.session }
 */
export const getUserSessionState = createSelector(
  getUserSession,
  (appState) => {
    return appState.session
  }
)

/**
 * Get user login errors from User state
 * @param {object} getUserSession
 * @param {string} (appState) => { return appState.error }
 */
export const getUserErrorState = createSelector(
  getUserSession,
  (appState) => {
    return appState.error
  }
)


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/selectors/user.ts